import schedules from './schedules'

export default {
  schedules
}
